export const SITE_NAME = "Data Commons";
export const SITE_LONG_NAME = "Data Commons";
export const CLIENT_NAME = "Hospice NZ"

export const SUPPORT_EMAIL = "data@hospice.org.nz";
export const CONTACT_EMAIL = SUPPORT_EMAIL;

export const SENTRY_DSN = "https://42eea71d1b5e420d82a2ad49da162a64@o143981.ingest.sentry.io/6024791"
export const SENTRY_RELSEASE = `${process.env.REACT_APP_PROJECT_NAME}@${process.env.REACT_APP_VERSION}`
